// IE region: everything that differs for this site. Registered in ../regionConfig.js.
export const config = {
  code: 'IE',
  sourceSite: 'digirep-ie',
  currency: 'EUR',
  supportEmail: 'hello@digitalreporting.ie',
  careEmail: 'hello@digitalreporting.ie',
  moneyPrefix: 'EUR ',
  companyIdLabel: 'Company number',
  filingServicesLabel: 'Revenue and CRO Filing Services',
  searchProviderLabel: 'Manual CRO entry',
  filingStatusLabels: {
    ch: 'CRO',
    hmrc: 'Revenue',
  },
  phonePlaceholder: '+353 85 123 4567',
  signupSubtitle: 'Ireland Revenue iXBRL managed filing services',
  accountTypes: [
    { value: 'ie_micro', label: 'Micro-Entity', subtitle: 'Simpler statutory accounts', price: 25 },
    { value: 'ie_small', label: 'Small Company', subtitle: 'Small company accounts', price: 50 },
    { value: 'ie_full', label: 'Standard / Full', subtitle: 'Full statutory accounts', price: 75 },
  ],
  optionalServices: [
    {
      id: 'revenue_ixbrl_filing',
      title: 'Revenue iXBRL Filing',
      description: 'We support your iXBRL filing workflow for Revenue',
      price: 50,
    },
    {
      id: 'cro_ixbrl_filing',
      title: 'CRO Filing Support',
      description: 'We support your accounts filing workflow for CRO',
      price: 25,
    },
  ],
  serviceCatalog: {
    revenue_ixbrl_filing: { title: 'Revenue iXBRL Filing', price: 50 },
    cro_ixbrl_filing: { title: 'CRO Filing Support', price: 25 },
  },
  delivery: {
    standard: { label: 'Standard (48 hours)', shortLabel: 'Standard', hours: '48h', surcharge: 0 },
    express: { label: 'Express (24 hours)', shortLabel: 'Express', hours: '24h', surcharge: 25 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = ['xbrl.digitalreporting.ie', 'preview.digitalreporting.ie'];
export const primaryHost = 'xbrl.digitalreporting.ie';
